module.exports = __webpack_public_path__ + "static/media/concourse.12d6f452.svg";